/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Linktarget1Inputs */

const en_entity_linktarget1 = /** @type {(inputs: Entity_Linktarget1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Target`)
};

const de_entity_linktarget1 = /** @type {(inputs: Entity_Linktarget1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link-Ziel`)
};

/**
* | output |
* | --- |
* | "Link Target" |
*
* @param {Entity_Linktarget1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_linktarget1 = /** @type {((inputs?: Entity_Linktarget1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Linktarget1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_linktarget1(inputs)
	return de_entity_linktarget1(inputs)
});
export { entity_linktarget1 as "entity_linkTarget" }